/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import guidebookDivorceSectionStyle from "./guidebookDivorceSectionStyle";
import CardLinked from "../../../Cards/CardLinked/CardLinked";
import * as guidebookDivorceContent from "../../../../containers/Pages/Divorce/GuidebookDivorceOverview/GuidebookDivorceCardContent";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";

const GuidebookDivorceSection = () => {
  return (
    <Container>
      <Typography variant={"h2"} sx={guidebookDivorceSectionStyle.header}>
        Ihr Scheidungsratgeber
      </Typography>
      <Grid container spacing={3} alignItems={"stretch"}>
        <Grid item xs={12} md={4}>
          <CardLinked
            linkTo={guidebookDivorceContent.guidebookDivorceRequirements.linkTo}
            image={guidebookDivorceContent.guidebookDivorceRequirements.image}
            headline={guidebookDivorceContent.guidebookDivorceRequirements.headline}
            text={guidebookDivorceContent.guidebookDivorceRequirements.text}
            altTitle={guidebookDivorceContent.guidebookDivorceRequirements.altTitle}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CardLinked
            linkTo={guidebookDivorceContent.guidebookDivorceDuration.linkTo}
            image={guidebookDivorceContent.guidebookDivorceDuration.image}
            headline={guidebookDivorceContent.guidebookDivorceDuration.headline}
            text={guidebookDivorceContent.guidebookDivorceDuration.text}
            altTitle={guidebookDivorceContent.guidebookDivorceDuration.altTitle}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CardLinked
            linkTo={guidebookDivorceContent.guidebookDivorceImportantTopics.linkTo}
            image={guidebookDivorceContent.guidebookDivorceImportantTopics.image}
            headline={guidebookDivorceContent.guidebookDivorceImportantTopics.headline}
            text={guidebookDivorceContent.guidebookDivorceImportantTopics.text}
            altTitle={guidebookDivorceContent.guidebookDivorceImportantTopics.altTitle}
          />
        </Grid>
      </Grid>
      <Typography sx={guidebookDivorceSectionStyle.centered}>Alle weiteren Informationen finden Sie hier:</Typography>
      <Box sx={guidebookDivorceSectionStyle.buttonContainer}>
        <Button sx={guidebookDivorceSectionStyle.infoButton} color={"primary"} component={Link} to={"/scheidung/ratgeber"}>
          zum Ratgeber
        </Button>
      </Box>
    </Container>
  );
};


export default GuidebookDivorceSection;
